import * as Yup from "yup";

const ContactUsSchema = Yup.object().shape({
	email: Yup.string().required("Required"),
	phoneNumber: Yup.string().required("Required"),
	address: Yup.string().required("Required"),
});

export default ContactUsSchema;